/* eslint-disable react/react-in-jsx-scope */
import { useEffect, useState } from "react";
import { InView } from "react-intersection-observer";

import publicConfig from "@lululemon/ecom-core/src/public-config";
import { useDeviceType } from "@lululemon/ecom-site/src/util/with-device-characteristics";
import { useLaunchDarklyFlag } from "@lululemon/mwa-launch-darkly";

import ReviewsContainer from "../../../containers/reviews-container/index";
import { loadBvScript } from "../../../containers/reviews-container/utils";
import { usePDPState } from "../../../context/PDPRoot.context";
import { usePDPRefs } from "../../../context/pdp-refs.context";
import useProductSummary from "../../../hooks/useProductSummary";
import useLocaleStandard from "../../../hooks/useLocaleStandard";
import {
  useActiveSwatchMediaInfo,
  useAllSize,
  useReviewsData,
} from "../../../hooks/use-product-attributes";
import useReviewsBVInjectedData from "../../../hooks/useReviewsBVInjectedData";

const PDPReviews = () => {
  const [isReviewFromEmail, setIsReviewFromEmail] = useState(false);
  const { writeAReviewCTARef, reviewsContainerRef } = usePDPRefs();
  const productSummary = useProductSummary();
  const reviewsData = useReviewsData();
  const activeSwatchMediaInfo = useActiveSwatchMediaInfo();
  const { reviewEmailReferral = "" } = useReviewsBVInjectedData();

  const locale = useLocaleStandard();
  const {
    pdpState: { bvAuthToken, isBvScriptLoaded, isReviewsLinkClicked },
    setPDPState,
  } = usePDPState();

  const allSize = useAllSize();

  const updateBvStatusScript = () => {
    setPDPState({ isBvScriptLoaded: true });
  };

  const [location, setLocation] = useState();
  useEffect(() => {
    setLocation(window.location);
  }, []);

  useEffect(() => {
    setIsReviewFromEmail(!!reviewEmailReferral);
  }, [reviewEmailReferral]);

  const pdpReviewsSummaryLDFlag = useLaunchDarklyFlag(
    "pdp-reviews-summary",
    false,
    publicConfig?.launchDarkly?.clientSideId
  );

  const { deviceType: { isMobile, isTablet } = {} } = useDeviceType();

  // NOTE: there are __6__ single child wrappers in this file. This need to be cleaned up.
  // We also need to consider the reviews' link scroll into view behavior when fixing this
  return (
    <div id="reviews-container-id" className="wrapper container-fluid">
      <div className="row">
        <div className="col-xs-12 product-reviews-wrapper">
          <div ref={reviewsContainerRef} data-testid="reviews-container">
            <InView
              rootMargin="100px"
              triggerOnce
              onChange={(inView) => loadBvScript(inView, updateBvStatusScript)}
            >
              {({ ref, inView }) => {
                return (
                  <div ref={ref}>
                    {(inView || isReviewFromEmail) && (
                      <ReviewsContainer
                        data-testid="reviews-container"
                        productId={
                          reviewsData?.bvId || productSummary?.bazaarVoiceID
                        }
                        productName={productSummary?.displayName}
                        isMobile={isMobile}
                        isMobileOrTablet={isMobile || isTablet}
                        isBvScriptLoaded={isBvScriptLoaded}
                        isReviewFromEmail={isReviewFromEmail}
                        writeAReviewCTARef={writeAReviewCTARef}
                        shouldAutoFocusCTA={isReviewsLinkClicked}
                        productImageUrl={activeSwatchMediaInfo?.[0]?.url}
                        productCategory={
                          productSummary?.parentCategoryUnifiedId
                        }
                        pdpUrl={productSummary?.pdpUrl}
                        location={location}
                        isReviewConfirmation={!!bvAuthToken}
                        pdpReviewsSummaryLDFlag={pdpReviewsSummaryLDFlag}
                        allSizes={allSize || []}
                        locale={locale}
                      />
                    )}
                  </div>
                );
              }}
            </InView>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PDPReviews;
